(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  // Re-align after banner images load; the theme supplies the sticky-header offset.
  const alignContactAnchor = () => {
    document.querySelectorAll('[data-contact-anchor]').forEach((target) => {
      if (window.location.hash === '#' + target.id) {
        target.scrollIntoView({ block: 'start', behavior: 'instant' });
      }
    });
  };

  if (document.readyState === 'complete') {
    alignContactAnchor();
  } else {
    window.addEventListener('load', alignContactAnchor, { once: true });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const selector = '[data-yg-indonesia-nav]';
    let countryRequest;

    function detectCountry() {
      if (!countryRequest) {
        countryRequest = (async () => {
          const controller = new AbortController();
          const timeout = window.setTimeout(() => controller.abort(), 5000);
          try {
            const root = window.Shopify?.routes?.root || '/';
            const url = new URL(root.replace(/\/$/, '') + '/browsing_context_suggestions.json', window.location.origin);
            url.searchParams.set('country[enabled]', 'true');
            const response = await fetch(url, {
              signal: controller.signal,
              credentials: 'same-origin',
              cache: 'no-store'
            });
            if (!response.ok) return null;
            const data = await response.json();
            // Only use the IP-detected country, never the selected market or suggestions.
            const country = data?.detected_values?.country?.handle;
            return typeof country === 'string' ? country.toUpperCase() : null;
          } catch {
            return null;
          } finally {
            window.clearTimeout(timeout);
          }
        })();
      }
      return countryRequest;
    }

    async function updateMenu(root = document) {
      const items = Array.from(root.querySelectorAll(selector));
      if (!items.length) return;
      items.forEach((item) => { item.hidden = true; });
      const country = await detectCountry();
      items.forEach((item) => {
        const language = (item.dataset.ygIndonesiaNav || '').toLowerCase().split('-')[0];
        item.hidden = !(country === 'ID' && (language === 'en' || language === 'id'));
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => updateMenu(), { once: true });
    } else {
      updateMenu();
    }
    document.addEventListener('shopify:section:load', (event) => updateMenu(event.target));
    window.addEventListener('pageshow', (event) => {
      if (event.persisted) {
        countryRequest = null;
        updateMenu();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wechat-article-grid"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class WechatArticleSwiper extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }

      connectedCallback() {
        if (this.swiper) return;
        this.swiper = this.initSwiper(this);
      }
    }

    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', WechatArticleSwiper);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-accordion"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGAccordion extends YGUtils {
      constructor() {
        super();
        this.swiperInstance = null;
        this.isMobileMode = false;
        this.isInitializing = true; // 标记正在初始化
        this.handleResize = this.handleResize.bind(this);
        this.debouncedResize = this.debounce(this.handleResize.bind(this), 150);
        this.handleItemHover = this.handleItemHover.bind(this);
        this.currentActiveItem = null;
      }

      get items() {
        return this.querySelectorAll('.yg-accordion-item');
      }

      connectedCallback() {
        // 初始化时根据当前屏幕尺寸设置正确的模式和监听器
        this.handleResize();
        window.addEventListener('resize', this.debouncedResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.debouncedResize);
        this.destroySwiper();
        this.removeHoverListeners();
      }

      initSwiper() {
        if (this.swiperInstance) return;

        // 如果是 folding card 模式且在移动端，不初始化轮播
        if (this.classList.contains('yg-accordion-folding-card') && this.isMobileMode) {
          return;
        }

        const galleryContainer = this.querySelector('.yg-accordion-item-container');
        const paginationElement = this.querySelector('.yg-accordion-pagination');
        const previousButton = this.querySelector('.yg-accordion-nav-prev');
        const nextButton = this.querySelector('.yg-accordion-nav-next');

        if (!galleryContainer) return;

        const autoplayEnabled = this.dataset.autoplay === 'true';
        const cycleSpeed = Number(this.dataset.cycleSpeed) || 5000;
        const swiperOptions = {
          spaceBetween: 12,
          slidesPerView: 1,
          autoHeight: true,
          on: {
            slideChange: () => {
              // 暂停所有视频
              this.items.forEach((item) => {
                this.controlVideo(item, 'pause');
              });
              // 播放当前活动的slide的视频
              const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
              if (activeSlide) {
                this.controlVideo(activeSlide, 'play');
              }
            },
          },
        };
        if (autoplayEnabled) {
          swiperOptions.autoplay = {
            delay: cycleSpeed,
            disableOnInteraction: false,
          };
        }

        if (paginationElement) {
          swiperOptions.pagination = {
            el: paginationElement,
            clickable: true,
          };
        }

        if (previousButton && nextButton) {
          swiperOptions.navigation = {
            prevEl: previousButton,
            nextEl: nextButton,
          };
        }

        this.swiperInstance = new Swiper(galleryContainer, swiperOptions);

        // 初始化时播放第一个活动的slide的视频
        setTimeout(() => {
          const activeSlide = galleryContainer.querySelector('.swiper-slide-active');
          if (activeSlide) {
            this.controlVideo(activeSlide, 'play');
          }
        }, 100);
      }

      destroySwiper() {
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      handleResize() {
        const width = window.innerWidth;
        const shouldBeMobile = width < 700;
        const modeChanged = shouldBeMobile !== this.isMobileMode;

        // 更新当前模式
        this.isMobileMode = shouldBeMobile;

        if (modeChanged || this.isInitializing) {
          if (shouldBeMobile) {
            // 切换到移动端模式
            this.removeHoverListeners();
            this.clearActiveItems();
            // 延迟初始化轮播，确保DOM已准备好
            setTimeout(() => this.initSwiper(), 50);
          } else {
            // 切换到PC端模式
            this.destroySwiper();
            this.addHoverListeners();
            // 重新激活当前项目（如果有的话）
            if (this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }
        }

        // 标记初始化完成
        this.isInitializing = false;
      }

      addHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.addEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
          item.addEventListener('mouseleave', this.handleItemHover);
        });
      }

      removeHoverListeners() {
        this.items.forEach((item) => {
          item.removeEventListener('mouseenter', this.handleItemHover);
          item.removeEventListener('mouseleave', this.handleItemHover);
        });
      }

      clearActiveItems() {
        this.items.forEach((item) => item.classList.remove('active'));
        this.currentActiveItem = null;
      }

      controlVideo(item, action) {
        const videoElement = item.querySelector('yg-video');
        if (videoElement && videoElement.pauseVideo && videoElement.playVideo) {
          // 检查是否有实际的视频内容
          const hasVideoContent = videoElement.type === 'video' && videoElement.videoContainer;
          if (hasVideoContent || videoElement.template) {
            if (action === 'play') {
              videoElement.playVideo();
            } else if (action === 'pause') {
              videoElement.pauseVideo();
            }
          }
        }
      }

      handleItemHover(e) {
        const type = e.type;
        const target = e.currentTarget;

        if (type === 'mouseenter') {
          this.items.forEach((item) => {
            item.classList.remove('active');
            this.controlVideo(item, 'pause');
          });
          target.classList.add('active');
          this.controlVideo(target, 'play');
          this.currentActiveItem = target;
        } else if (type === 'mouseleave') {
          setTimeout(() => {
            const hoverItem = [...this.items].find((item) => item.matches(':hover'));
            if (!hoverItem && this.currentActiveItem) {
              this.currentActiveItem.classList.add('active');
              this.controlVideo(this.currentActiveItem, 'play');
            }
          }, 10);
        }
      }
    }

    if (!window.customElements.get('yg-accordion')) {
      window.customElements.define('yg-accordion', YGAccordion);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-case-image-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-case-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-contact-mascot"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('yg-contact-mascot')) {
    customElements.define('yg-contact-mascot', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const { signal } = this.controller;
        const initialScrollY = window.scrollY;

        const startTimer = () => {
          if (window.scrollY === initialScrollY) return;
          window.removeEventListener('scroll', startTimer);
          this.timer = window.setTimeout(() => {
            this.hidden = false;
          }, 10000);
        };

        if (this.hidden) {
          window.addEventListener('scroll', startTimer, { passive: true, signal });
        }

        this.querySelector('a').addEventListener('click', (event) => {
          // The theme's global anchor handler also matches links to other domains.
          event.stopPropagation();
          if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;

          const destination = new URL(event.currentTarget.href);
          if (destination.origin !== window.location.origin || destination.pathname !== window.location.pathname) return;

          const target = document.getElementById('cooperation-form');
          if (!target) return;

          event.preventDefault();
          if (window.location.hash !== destination.hash) {
            window.history.pushState(null, '', destination.hash);
          }
          target.scrollIntoView({
            block: 'start',
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
          });
        }, { signal });
      }

      disconnectedCallback() {
        this.controller.abort();
        window.clearTimeout(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-full-image-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-image-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yg-multi-column"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    class YGSwiperCard extends YGUtils {
      constructor() {
        super();
        this.swiper = null;
      }
      connectedCallback() {
        // 避免多次初始化
        if (this.swiper) return;

        this.swiper = this.initSwiper(this);
      }
    }
    if (!customElements.get('yg-swiper-card')) {
      customElements.define('yg-swiper-card', YGSwiperCard);
    }
  });

  } catch(e) { console.error(e); }
})();
})();
